function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "blog",
  transform: "translate(-1.000000, -3.000000)",
  fill: "#3B3A42"
}, React.createElement("path", {
  d: "M14.4528,15 L14.4528,13 L6,13 L6,11 L14.9932681,11 L16.7093715,9 L6,9 L6,7 L18.4254748,7 L20.1415782,5 L3.0002,5 L3.0002,19 L25.0002,19 L25.0002,10.912132 L19.920816,17.0001 L14.4528,17.0001 L6,17 L6,15 L14.4528,15 Z M17.077,15.0001 L18.984784,15.0001 L24.6175854,8.24882582 L22.0160138,5.88678023 L16.4528,12.3703218 L16.4528,15 L17.077,15 Z M17.225774,21 C18.0035086,21.7888828 19.0415208,22.6834764 20.0005,23 L20.0005,24 L7.9995,24 L7.9995,23 C8.96021279,22.6885084 10.0051123,21.7913305 10.7885841,21 L2.3622,21 C1.6102,21 1.0002,20.39 1.0002,19.638 L1.0002,4.362 C1.0002,3.61 1.6102,3 2.3622,3 L25.6382,3 C26.3902,3 27.0002,3.61 27.0002,4.362 L27.0002,6.176 L27.0002,7.71071311 L27.3820146,8.05737418 L27.0002,8.51500356 L27.0002,9.353 L27.0002,19.638 C27.0002,20.39 26.3902,21 25.6382,21 L17.225774,21 Z M25.0002,5.89485256 L25.0002,5 L24.0146039,5 L25.0002,5.89485256 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "27px",
    height: "21px",
    viewBox: "0 0 27 21",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/blog.1285d237.svg";
export { SvgComponent as ReactComponent };